var _path, _path2, _g, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLandArea = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#land_area_svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  fillRule: "evenodd",
  d: "M7.453 28.547h21.094V7.453H7.453z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "land_area_svg__b",
  width: 36,
  height: 36,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 22.926,
  strokeWidth: 1.5,
  mask: "url(#land_area_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.703 4.219H4.22V.703H.703zM.703 19.758H4.22v-3.516H.703zM.703 35.297H4.22V31.78H.703zM16.242 4.219h3.516V.703h-3.516zM16.242 35.297h3.516V31.78h-3.516zM31.781 4.219h3.516V.703H31.78zM31.781 19.758h3.516v-3.516H31.78zM31.781 35.297h3.516V31.78H31.78z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "land_area_svg__c",
  width: 36,
  height: 36,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 22.926,
  strokeWidth: 1.5,
  mask: "url(#land_area_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.605 2.46h.704M8.121 2.46h.703M11.637 2.46h.703M15.152 2.46h.704M20.145 2.46h.703M23.66 2.46h.703M27.176 2.46h.703M30.691 2.46h.704M2.46 31.395v-.704M2.46 27.879v-.703M2.46 24.363v-.703M2.46 20.848v-.703M2.46 15.856v-.704M2.46 12.34v-.703M2.46 8.824v-.703M2.46 5.309v-.704M31.395 33.54h-.704M27.879 33.54h-.703M24.363 33.54h-.703M20.848 33.54h-.703M15.856 33.54h-.704M12.34 33.54h-.703M8.824 33.54h-.703M5.309 33.54h-.704M33.54 4.605v.704M33.54 8.121v.703M33.54 11.637v.703M33.54 15.152v.704M33.54 20.145v.703M33.54 23.66v.703M33.54 27.176v.703M33.54 30.691v.704"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "land_area_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
})))));
export default SvgLandArea;